export const GET_USER_CURRENCIES_START = 'GET_USER_CURRENCIES_START';
export const GET_USER_CURRENCIES_SUCCESS =
  'GET_USER_CURRENCIES_SUCCESS';
export const GET_USER_CURRENCIES_ERROR = 'GET_USER_CURRENCIES_ERROR';
